@if (event) {
    <div class="card-scoreboard_stats pair_game">
        <div class="card-scoreboard_stats-values card-scoreboard_stats-values-pair">
            <div class="card-scoreboard_stats-column bold" style="display: flex">
                <div class="cell highlight">
                    <div>{{ score.participant1 }}</div>
                </div>
                <div class="card-scoreboard_stats-values-pair__score-divider">-</div>
                <div class="cell highlight">
                    <div>{{ score.participant2 }}</div>
                </div>
            </div>
        </div>
    </div>
}
